module.exports = __webpack_public_path__ + "img/00037.d8a60543.webp";